import { Affix, Card, Transition, rem } from '@mantine/core';
import type { CSSProperties, PropsWithChildren } from 'react';
import type { EmotionSx } from '@mantine/emotion';

type Props = {
  mounted: boolean;
  maxWidth?: number;
  justifyContent?: CSSProperties['justifyContent'];
  zIndex?: number;
  variant?: 'default' | 'save';
  withinPortal?: boolean;
  sx?: EmotionSx;
};

export const ActionBar = ({
  mounted,
  children,
  maxWidth = 700,
  justifyContent = 'space-between',
  zIndex = undefined,
  variant = 'default',
  withinPortal = true,
  sx,
}: PropsWithChildren<Props>) => {
  return (
    <Affix
      sx={(theme, u) => ({
        transition: 'all 0.3s ease-in-out',
        left: '50%',
        transform: 'translateX(-50%)',
        minWidth: rem(maxWidth < 800 ? 800 : maxWidth),
        bottom: rem(30),
        ...(typeof sx === 'function' ? (sx(theme, u) as any) : sx),
      })}
      zIndex={zIndex}
      withinPortal={withinPortal}
    >
      <Transition transition="slide-up" mounted={mounted}>
        {(style) => (
          <Card
            shadow="lg"
            style={style}
            withBorder
            radius={variant === 'save' ? 'lg' : 'md'}
            py={variant === 'save' ? 'xs' : 'xs'}
            px={variant === 'save' ? 'xs' : 'sm'}
            pl={variant === 'save' ? 'md' : undefined}
            bg={variant === 'save' ? 'dark' : 'white'}
            sx={(theme) => ({
              maxWidth: rem(maxWidth),
              marginInline: 'auto',
              display: 'flex',
              justifyContent,
              alignItems: 'center',
              flexDirection: 'row',
              color: variant === 'save' ? 'white' : undefined,
              fontSize: variant === 'save' ? theme.fontSizes.xs : undefined,
            })}
          >
            {children}
          </Card>
        )}
      </Transition>
    </Affix>
  );
};
